export const getDataViewerPageTour = () => [
  {
    target: 'body',
    title: 'Data visning',
    content:
      'Data visning er stedet, hvor du kan se og analysere målt data fra dine units. Her vælger du, hvilke units du vil se data for, hvilken periode data skal vises fra, og hvordan data skal aggregeres i grafen.',
    placement: 'center',
    disableBeacon: true,
  },
  {
    target: '[data-tour="data-viewer-units"]',
    title: 'Vælg units til visning',
    content:
      'Start med at vælge én eller flere units i dropdown-menuen. De valgte units bestemmer, hvilket målt data der bliver vist i grafområdet.',
    placement: 'bottom',
  },
  {
    target: '[data-tour="data-viewer-date-range"]',
    title: 'Vælg fra- og til-dato',
    content:
      'Her vælger du, hvilket tidspunkt datavisningen skal starte fra og slutte ved. Kun data frem til dette tidspunkt bliver inkluderet i grafen.',
    placement: 'bottom',
  },
  {
    target: '[data-tour="data-viewer-aggregation"]',
    title: 'Vælg aggregeringstype',
    content:
      'Aggregering bestemmer, hvordan data samles og vises i grafen. Du kan vælge mellem automatisk visning, rådata, 5 minutter, time eller dag, afhængigt af hvor detaljeret data skal vises.',
    placement: 'bottom',
  },
  {
    target: '[data-tour="data-viewer-live"]',
    title: 'Live',
    content:
      'Klik på “Live” for at følge de nyeste målinger løbende. Live-visning er nyttig, når du vil overvåge data tæt på realtid.',
    placement: 'left',
  },
];
